import React, { Component } from "react"
import { Popover, PopoverBody } from "reactstrap"

import AddConceptMappingModal from "../../common/AddConceptMappingModal"

class ConceptTag extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPopoverOpen: false,
            isMappingModalOpen: false,
            escapedId: this.escapeId(props.concept.id),
            escapedParentPrefix: this.escapeId(props.parentPrefix)
        }
        this.togglePopover = this.togglePopover.bind(this)
        this.toggleMappingModal = this.toggleMappingModal.bind(this)
    }

    UNSAFE_componentWillReceiveProps({ concept: { id } }) {
        this.setState({
            escapedId: this.escapeId(id)
        })
    }

    escapeId(id) {
        return `_${id.replace(/\W/g, "")}`
    }

    togglePopover() {
        this.setState({
            isPopoverOpen: !this.state.isPopoverOpen
        })
    }

    toggleMappingModal() {
        this.setState({
            isMappingModalOpen: !this.state.isMappingModalOpen,
            isPopoverOpen: !this.state.isPopoverOpen
        })
    }

    render() {
        const { concept, canEdit, uri } = this.props
        const { escapedParentPrefix, escapedId } = this.state
        const fullId = `${escapedParentPrefix}-${escapedId}`
        return (
            <div
                className="tag-item grey"
                onClick={this.togglePopover}
                id={fullId}
                role="button"
                tabIndex="0"
            >
                {concept.name}
                <Popover
                    placement="top"
                    isOpen={this.state.isPopoverOpen}
                    target={fullId}
                    toggle={this.togglePopover}
                    trigger="legacy"
                >
                    <PopoverBody>
                        <div className="list-group" aria-labelledby={fullId}>
                            {uri && (
                                <a
                                    href={uri}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="list-group-item"
                                >
                                    See description
                                </a>
                            )}
                            <p className="list-group-item no-highlight">
                                Relevance: {concept.score}
                            </p>
                            {concept.classifier && (
                                <p className="list-group-item no-highlight">
                                    Classifier: {concept.classifier}
                                </p>
                            )}
                            {canEdit ? (
                                <button
                                    className="list-group-item"
                                    onClick={this.toggleMappingModal}
                                >
                                    Add mapping&hellip;
                                </button>
                            ) : null}
                        </div>
                    </PopoverBody>
                </Popover>
                {this.state.isMappingModalOpen ? (
                    <AddConceptMappingModal
                        isOpen={this.state.isMappingModalOpen}
                        concept={concept}
                        toggle={this.toggleMappingModal}
                    />
                ) : null}
            </div>
        )
    }
}

export default ConceptTag
